import React from 'react';
import ReactExport from 'react-data-export';
import styled from 'styled-components';
import palette from '../../../lib/styles/palette';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const BtnExcelDownload = styled.button`
    width: 150px;
    padding: 5px 0;
    background-color: ${palette.webCyan[5]};
    color: #fff;
    font-size: 1rem;
    border: 0;
    border-radius: .2rem;
    cursor: pointer;

    &:disabled {
        background-color: ${palette.webGray[4]};
        cursor: default;
    }

    &:focus {
        outline: none;
    }
`;

const LessonMemberDownloadExcel = ({ dataSet, fileName, sheetName }) => {
    if (!dataSet || dataSet.length === 0) {
        return <BtnExcelDownload disabled>엑셀 다운로드</BtnExcelDownload>;
    }

    return (
        <ExcelFile
            filename={fileName}
            element={<BtnExcelDownload>엑셀 다운로드</BtnExcelDownload>}
        >
            <ExcelSheet data={dataSet} name={sheetName || '레슨 회원 목록'}>
                <ExcelColumn label="회원 이름" value="name" width={200} />
                <ExcelColumn label="나이" value="age" />
                <ExcelColumn label="생년월일" value="birth" />
                <ExcelColumn label="연락처" value="phone" width={200} />
                <ExcelColumn label="이메일" value="account" width={200} />
                <ExcelColumn label="담당 강사" value="coachName" />
                <ExcelColumn label="회원권" value="title" width={200} />
                <ExcelColumn label="수강 회차" value="attendCount" />
                <ExcelColumn label="전체 회차" value="totalCount" />
                <ExcelColumn label="시작일" value="startDate" />
                <ExcelColumn label="종료일" value="endDate" />
                <ExcelColumn label="상태" value="state" />
            </ExcelSheet>
        </ExcelFile>
    );
};

export default LessonMemberDownloadExcel;
